import { serviceRoles } from "config/access";
import { AUTHORS } from "constants/routes";
import { checkAccess } from "helpers/auth";
import AuthorsPage from "./container/AuthorsPage";

export default function getSettingsRoute(requireAuthFunctions) {
  const { account, cpfm } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
    [cpfm.name]: [cpfm.roles.admin],
  };
  return {
    path: AUTHORS,
    onEnter: () => checkAccess(requireAuth, requireAuthFunctions),
    withSidebar: true,
    withAppBar: true,
    component: AuthorsPage,
  };
}
